/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexVariantDto } from '../../models/backend-capex-variant-dto';
import { BackendPatchedCapexVariantRequestDto } from '../../models/backend-patched-capex-variant-request-dto';

export interface EconomicIndicatorsCapexVariantsPartialUpdate$FormData$Params {
  /**
   * A unique integer value identifying this capex variant.
   */
  id: number;
  body?: BackendPatchedCapexVariantRequestDto;
}

export function economicIndicatorsCapexVariantsPartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: EconomicIndicatorsCapexVariantsPartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexVariantDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexVariantsPartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexVariantDto>;
    }),
  );
}

economicIndicatorsCapexVariantsPartialUpdate$FormData.PATH = '/api/economic_indicators/capex_variants/{id}/';
